import(/* webpackChunkName: "login-layout" */ "Layouts/login");

$(function() {
	$('.js-form-lost-password').validate({
        submitHandler: function(form) {
            form.submit();
        }
	});

    $('.js-not-vat-payer').on('change', function () {
        const isChecked = $(this).is(':checked'),
            $vatNumInput = $('.js-vat-num-input');

        $vatNumInput.prop('required', !isChecked);
        $vatNumInput.parents('.c-form__item').first().toggleClass('is-required', !isChecked);
    });

    $('.js-is-vinary').on('change', function () {
        const isChecked = $(this).is(':checked'),
            $sblInput = $('.js-sbl-input');

        $sblInput.prop('required', !isChecked);
        $sblInput.parents('.c-form__item').first().toggleClass('is-required', !isChecked);
    });
});